<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            Repair Analytics
            <small style="font-weight:600; color:#20a8d8">
              (YTD)
              <!--{{ from ? $formatUSDate(from) : $formatUSDate(dateFrom) }}-->
              <!--<b>|</b>-->
              <!--{{ to ? $formatUSDate(to) : $formatUSDate(dateTo) }}-->
            </small>
          <!-- <b-button
              @click="detailView"
              class="btn-outline btn-sm ml-3"
              variant="outline-primary"
              right
            >
              Product Groups
          </b-button> -->
          </h5>
          <div class="card-header-actions">
            <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadPDF()"
            >
              <i class="fa fa-file-pdf-o" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
            </b-button>
          </div>
        </div>
          <div style="width: 100%; display: flex; justify-content: flex-end;">
          <!-- <h5>Quantity</h5>
          <c-switch
            class="mx-1"
            color="primary"
            v-model="valueQuantity"
            value="true"
            uncheckedValue="false"
            variant="pill"
          />
          <h5>Financials</h5> -->
        </div>
        <div class="chart-wrapper">
          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
          <!-- <b-form-checkbox
            id="checkbox-1"
            class="mx-1"
            v-model="toggleData"
            name="checkbox-1"
            value="true"
            unchecked-value="false"
          >Show / Hide All</b-form-checkbox> -->
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../router";
import Datepicker from "vuejs-datepicker";
import { Switch as cSwitch } from "@coreui/vue";

export default {
  name: "RepairAnalytics-Stacked",
  components: {
    router,
    highcharts: Chart,
    cSwitch
    //Datapicker
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity"],
  data: function() {
    return {
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      valueQuantity: false,
      toggleData: false,
      dateFrom: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {
        tooltip: {
          formatter: function() {
            return;
          }
        },
        chart: {
          type: "column",
          backgroundColor: "transparent"
        },
        exporting: {
          enabled: true
        },
        title: {
          text: ""
        },
        legend: {
          itemStyle: {
            color: "white"
          }
        },
        xAxis: {
          categories: [],
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total repair by Month"
          },
          labels: {
            style: {
              color: "white"
            }
          },
          stackLabels: {
            enabled: false,
            formatter: function() {
              return "Total: " + this.total;
            },
            style: {
              fontWeight: "bold",
              color: "white"
            }
          }
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              formatter: function() {
                return "TEST";
              }
            }
          }
        },
        series: []
      }
    };
  },

  watch: {
    valueQuantity(value) {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    },
    toggleData(param) {
      var chartSeries = this.$refs.backRef.chart.series;
      chartSeries.forEach(obj => {
        if (param === "false") {
          obj.show();
        } else {
          obj.hide();
        }
      });
    }
  },

  methods: {
    detailView() {
      this.$emit("detailViewRepair");
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      let params = {};
      params = {
        date_from: "2020-01-01",
        date_to: this.dateTo,
        type: finType
      };
      this.$http
        .get("api/aoi/charts/repair.php", {
          params
        })
        .then(
          res => {
            let myArray = res.data;
            let xAxis = [];
            var datum = [];

            var fiber = {
              name: "Total",
              data: [],
              color: "rgb(124, 181, 236)"
            };

            for (var type in myArray) {
              datum.push([type, myArray[type]]);
            }
            datum.forEach(obj => {
              var last2 = obj[0].slice(-2);
              if (last2 == "01") {
                xAxis.push("January");
              }
              if (last2 == "02") {
                xAxis.push("February");
              }
              if (last2 == "03") {
                xAxis.push("March");
              }
              if (last2 == "04") {
                xAxis.push("April");
              }
              if (last2 == "05") {
                xAxis.push("May");
              }
              if (last2 == "06") {
                xAxis.push("June");
              }
              if (last2 == "07") {
                xAxis.push("July");
              }
              if (last2 == "08") {
                xAxis.push("August");
              }
              if (last2 == "09") {
                xAxis.push("September");
              }
              if (last2 == "10") {
                xAxis.push("October");
              }
              if (last2 == "11") {
                xAxis.push("November");
              }
              if (last2 == "12") {
                xAxis.push("December");
              }

            fiber.data.push(obj[1].Total);
            });

            this.chartOptions.xAxis.categories = xAxis;
            this.chartOptions.series[0] = fiber;

            this.chartOptions.series[0].color = 'rgb(144, 237, 125)';


            if (finType == "Fin") {
              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": $" +
                  this.y.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return "$" + this.y.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return "Total: " + "$" + this.total.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
              };
            } else {
              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": " +
                  this.y +
                  " units"
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return this.y;
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return "Total: " + this.total;
              };
            }

            this.loadingData = false;
          },
          err => {
            console.log(err);
            this.loadingData = false;
          }
        );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    modalDateEvent() {
      if (this.fullScreen) {
        this.toggleFullScreen();
        this.modalDate = true;
      } else {
        this.modalDate = true;
      }
    },
    downloadPDF() {
      this.$refs.backRef.chart.options.title.text =
        "Repair Analytics By Product Type | Year-to-date (YTD)";

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.options.yAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "RepariAnalyticsByProductGroup-" + this.dateTo
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "white";
    }
  },
  mounted() {
    if (!localStorage.getItem("aoi_user")) {
      router.push("/pages/login/");
    }

    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }
    this.valueQuantity = false;

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
